import {
  useFlowSessionById,
  useUpdateFlowSessionReadStatus,
} from "@/api/flow_sessions";
import { useInboxItemById } from "@/api/inbox";
import ChatArea from "@/components/ChatArea";
import SessionNameMenu from "@/components/Sidebar/SessionNameMenu";
import { MessageInputProvider } from "@/context/MessageInputContext";
import { SessionProvider } from "@/context/SessionContext";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ROUTES } from "@/constants/routes";

const SessionPage: React.FC = () => {
  const { sessionId, inboxItemId } = useParams<{
    sessionId?: string;
    inboxItemId?: string;
  }>();
  const navigate = useNavigate();

  const { data: inboxItem, isLoading: isInboxItemLoading } = useInboxItemById(
    inboxItemId || "",
    { enabled: !!inboxItemId },
  );

  const resolvedSessionId = inboxItem?.flow_session_id || sessionId;

  const { data: flowSession, isLoading: isFlowSessionsLoading } =
    useFlowSessionById(resolvedSessionId || "", {
      enabled: !!resolvedSessionId,
    });

  const { mutate: updateFlowSessionReadStatus } =
    useUpdateFlowSessionReadStatus();

  useEffect(() => {
    if (flowSession?.read_status === "unread" && resolvedSessionId) {
      updateFlowSessionReadStatus({
        flowSessionId: resolvedSessionId,
        readStatus: "read",
      });
    }
  }, [
    flowSession?.read_status,
    resolvedSessionId,
    updateFlowSessionReadStatus,
  ]);

  if (isFlowSessionsLoading || isInboxItemLoading) {
    return null;
  }

  return (
    <>
      <title data-tracking-title="Chat">{flowSession?.name}</title>

      <div id="session-page" className="h-full flex flex-col">
        <div className="h-full">
          <div className="absolute top-0 left-0 flex items-center justify-center w-full z-10">
            <SessionNameMenu
              sessionId={resolvedSessionId!}
              onDelete={() => {
                navigate(ROUTES.HOME);
              }}
            />
          </div>

          <div className="h-full flex flex-col w-full scrollbar-hide">
            <SessionProvider initialSessionId={resolvedSessionId!}>
              <ChatArea
                className="[&>:first-child]:pt-[100px]"
                location="main"
              />
            </SessionProvider>
          </div>
        </div>
      </div>
    </>
  );
};

export default () => {
  return (
    <MessageInputProvider>
      <SessionPage />
    </MessageInputProvider>
  );
};
